var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMoveTo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H10L8 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM12.8123 12.3501C12.485 12.612 12 12.3789 12 11.9597V10H9C8.44771 10 8 9.55229 8 9C8 8.44771 8.44771 8 9 8H12V6.04031C12 5.62106 12.485 5.38797 12.8123 5.64988L16.512 8.60957C16.7622 8.80973 16.7622 9.19027 16.512 9.39043L12.8123 12.3501Z",
    fill: "#606165"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveTo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move-to.a4cfbec1.svg";
export { ForwardRef as ReactComponent };